module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tm-442986488503d5356e8026045953e0d6.svg";